// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1BRO4","actionsCol":"EnrolledClinics_actionsCol__2On33"};